<template>
  <div>
    <Header></Header>
    <div class="magezineInCon">
      <div class="con">
        <el-carousel
          trigger="click"
          height="60vh"
          arrow="always"
          :interval="2000"
          indicator-position="none"
          :autoplay="false"
          :initial-index="index"
        >
          <el-carousel-item v-for="(item, index) in items" :key="index">
            <img :src="item.cover" alt="" />
            <span>{{ item.title }}</span>
            <p>{{ item.content }}</p>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../../components/Header_M.vue'
export default{
  components:{
      Header
  },
  data() {
    return {
      items: [],
      index: 0,
      magazine: ''
    };
  },
  mounted() {
    this.magazine = this.$route.params.magazine
    this.getData()
  },
  methods: {
    async getData() {
      const magazine = await this.$axios.get("magazine", {
      });
      this.items = magazine.data;
      for (let i = 0; i < this.items.length; i++) {
        if(this.magazine == this.items[i].title){
          this.index = i
        }
      }
    }
  }
};
</script>
<style scoped>
.magezineInCon {
  width: 100%;
  height: 100vh;
  background-color: #000;
  padding: 50px 0 10px 0;
  display: flex;
  align-items: center;
}
::-webkit-scrollbar {
  display: none;
}
.magezineInCon .con {
  width: 100%;
  height: 60vh;
  position: fixed;
}
.magezineInCon .con .el-carousel__item {
  width: 100%;
  color: #fff;
}
.magezineInCon .con .el-carousel__item img {
  width: inherit;
  height: 50%;
  object-fit: contain;
  padding: 20px;
}
.magezineInCon .con .el-carousel__item span {
  margin: 0 20px;
  font-size: 22px;
  font-weight: bold;
  color: #fff;
}
.magezineInCon .con .el-carousel__item p {
  margin: 15px 20px;
  font-size: 15px;
  color: #888;
  word-break: break-word;
  text-align: justify;
}
.magezineInCon .con /deep/ .el-carousel__arrow {
  width: 40px;
  height: 40px;
  border: 1px solid #888;
  font-size: 18px;
  color: #888;
  transform: translateY(-18vh);
}
.magezineInCon .con /deep/ .el-carousel__arrow--left {
  left: 5%;
}
.magezineInCon .con /deep/ .el-carousel__arrow--right {
  right: 5%;
}
.magezineInCon .con .box {
  width: calc(100vw - 40px);
  height: calc(100vh - 50px - 60vh - 40px);
  background: #333;
  margin: 20px;
}
</style>


// WEBPACK FOOTER //
// src/view/mobile/Magazine.vue